import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

const GenderSelector = ({ onGenderSet }) => {
  const [selected, setSelected] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!selected) return;
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_BASE_URL}/api/auth/update-gender`, 
        { gender: selected },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onGenderSet(selected);
    } catch (err) {
      console.error('Error saving gender:', err);
    }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm" data-testid="gender-selector-modal">
      <div className="bg-white rounded-2xl p-8 max-w-sm w-full mx-4 shadow-2xl">
        <h3 className="text-xl font-bold text-center mb-2 text-gray-800">Selecciona tu personaje</h3>
        <p className="text-sm text-gray-500 text-center mb-6">Elige tu género para personalizar tu avatar en el Camino del Médico</p>
        
        <div className="flex gap-4 mb-6">
          <button
            onClick={() => setSelected('male')}
            data-testid="gender-select-male"
            className={`flex-1 flex flex-col items-center p-4 rounded-xl border-2 transition-all ${
              selected === 'male'
                ? 'border-sky-500 bg-sky-50 shadow-lg'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <img
              src="/sprites/estudiante_de_medicina_male.png"
              alt="Hombre"
              className="w-20 h-24 object-contain mb-2"
            />
            <span className={`font-semibold text-sm ${selected === 'male' ? 'text-sky-600' : 'text-gray-700'}`}>
              Hombre
            </span>
          </button>

          <button
            onClick={() => setSelected('female')}
            data-testid="gender-select-female"
            className={`flex-1 flex flex-col items-center p-4 rounded-xl border-2 transition-all ${
              selected === 'female'
                ? 'border-sky-500 bg-sky-50 shadow-lg'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <img
              src="/sprites/estudiante_de_medicina_female.png"
              alt="Mujer"
              className="w-20 h-24 object-contain mb-2"
            />
            <span className={`font-semibold text-sm ${selected === 'female' ? 'text-sky-600' : 'text-gray-700'}`}>
              Mujer
            </span>
          </button>
        </div>

        <button
          onClick={handleSave}
          disabled={!selected || saving}
          data-testid="gender-save-btn"
          className={`w-full py-3 rounded-lg font-semibold transition-all ${
            selected
              ? 'bg-black text-white hover:bg-gray-800'
              : 'bg-gray-200 text-gray-400 cursor-not-allowed'
          }`}
        >
          {saving ? 'Guardando...' : 'Confirmar'}
        </button>
      </div>
    </div>
  );
};

export default GenderSelector;
